export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4771.c5977632.jpg";